import React from 'react';
import "./yearbookSearchCard.scss";

const YearbookSearchCard = ({props}) => {

    const {typename, title, lang_code, recurrence_year, recurrence_volume, body, about, highlighted, chapter_num, intro, slug } = props;

    return(
        <div className="publication-item publication-post py-5">
            <div className="d-flex flex-row">
                <div className="card-body d-flex flex-column justify-content-between">
                    <div className="">
                        <h4 className="card-title post-title has-lines-2">
                            {typename === 'YearbookPage' && <a href={`/${slug}`}>{`${recurrence_year} Disarmament Yearbook - Homepage`}</a>}
                            {typename === 'YearbookForeword' && <a href={`/${recurrence_year}/${slug}`}>{`${recurrence_year} Disarmament Yearbook - ${title}`}</a>}
                            {typename === 'YearbookChapter' && <a href={`/${recurrence_year}/${slug}`}>{`${recurrence_year} Disarmament Yearbook - ${title}`}</a>}
                        </h4>
                        {
                            typename === 'YearbookPage' && <div>{about.substring(0, 400)}...</div>
                        }
                        {
                            typename === 'YearbookForeword' && highlighted.body &&
                            highlighted.body.map((highlight, index) => {
                                return (
                                    <div className={'mb-2'}>
                                        <span key={index} className={'highlighted'} dangerouslySetInnerHTML={{__html: highlight}}></span><span><strong>...</strong></span>
                                    </div>
                                )
                            })
                            || typename === 'YearbookForeword' && !highlighted.body && <div>{body.substring(0, 400)}...</div>
                        }
                        {
                            typename === 'YearbookChapter' && highlighted.body &&
                            highlighted.body.map((highlight, index) => {
                                return (
                                    <div className={'mb-2'}>
                                        <span key={index} className={'highlighted'} dangerouslySetInnerHTML={{__html: highlight}}></span><span><strong>...</strong></span>
                                    </div>
                                )
                            })
                            || typename === 'YearbookChapter' && highlighted.initial_quote_quote && <div className={'highlighted'} dangerouslySetInnerHTML={{__html: highlighted.initial_quote_quote}}></div>
                            || typename === 'YearbookChapter' && !highlighted.body && <div>{body.substring(0, 400)}...</div>
                        }
                        {/*<div className={'mt-1 post-subtitle d-flex flex-row-reverse'}><strong>{typename}</strong></div>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default YearbookSearchCard;
